import { connect } from "react-redux";
import SocialActivities from "../components/SocialActivities";
import { fetchActivity } from "../actions";
var mapStateToProps = function(state, _ownProps) {
    return {
        session: state.session,
        activities: state.activities
    };
};
var mapDispatchToProps = function(dispatch, _ownProps) {
    return {
        fetchActivity: function(activity, topic) {
            dispatch(fetchActivity({
                activity: activity,
                topic: topic
            }));
        }
    };
};
export default connect(mapStateToProps, mapDispatchToProps)(SocialActivities);
